import { trackRetailerOnboardingTopPromoBannerView } from "@faire/web-api/events/retailerOnboarding/view/topPromoBanner";
import brandPortal from "@faire/web-api/routes/brand-portal";
import { Button } from "@faire/web/slate/Button";
import { Typography } from "@faire/web/slate/Typography";
import { AlertBanner } from "@faire/web/ui/AlertBanner";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";
import { useEffect, type JSX } from "react";

import { PromoBannerType } from "@faire/retailer/components/Notifications/PromoBanner/bannerOrder";
import { usePromoBanners } from "@faire/retailer/stores/ui/usePromoBanners";

export const BrandPreviewBanner: React.FC = () => {
  useEffect(() => {
    // Special case banner that is not part of the normal banner rotation
    trackRetailerOnboardingTopPromoBannerView(PromoBannerType.BRAND_PREVIEW);
  }, []);

  const { backgroundColor, textColor } = usePromoBanners();
  const LinkFormatting = getLinkFormatting(textColor);
  return (
    <AlertBanner
      color={backgroundColor}
      message={
        <Typography color={textColor} align="center">
          <StrictLocalMsg
            defaultMessage="This is a preview of your shop. When you’re ready, you can activate this page from <LinkFormatting>your portal</LinkFormatting>."
            description={{
              text: "this is the banner text to inform this is a preview of the shop",
            }}
            values={{
              LinkFormatting: LinkFormatting,
            }}
          />
        </Typography>
      }
    />
  );
};

const getLinkFormatting = (color: string) => {
  return function (chunks: JSX.Element) {
    return (
      <Button variant="tertiary" tertiaryColor={color} linkTo={brandPortal()}>
        {chunks}
      </Button>
    );
  };
};
